import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useParams, useLocation } from 'react-router-dom';

// components
import Header from '../../../components/Header/Header';
import Navbar from '../../../components/Navbar/Navbar';
import Breadcrumbs from '../../../components/Breadcrumbs';

// icons
import leads from '../../../brand/generated/sidebar/deals.svg';
import getDealItemsCount from '../../../api/deals/getDealItemsCount';
import Loader from '../../../components/Loader/Loader';
import { PAYMENT_TYPES_CREDIT_CARD, PAYMENT_TYPES_CREDIT_INVOICE, PAYMENT_TYPES_PREPAYMENT_CARD, PAYMENT_TYPES_PREPAYMENT_INVOICE } from '../../../constants';
import getCrmSidebarNotificationsCount from '../../../api/sidebar/getCrmSidebarNotificationsCount';

const NotaryDealNavigation = ({ to }) => {
  const { id } = useParams();
  const [equipmentsCount, setEquipmentsCount] = useState({});

  const { pathname } = useLocation();
  const [items, setItems] = useState([
    { text: '100% Ð¾Ð¿Ð»Ð°ÑÐ°', navigate: `/notary/deals/prepayment` },
    { text: 'ÐÑÐµÐ´Ð¸Ñ', navigate: `/notary/deals/credit` },
  ]);

  const init = async () => {
    getCrmSidebarNotificationsCount().then((res) => {
      setItems([
        { text: '100% Ð¾Ð¿Ð»Ð°ÑÐ°', navigate: `/notary/deals/prepayment`, new: res?.data?.dealAbsolutePayment},
        { text: 'ÐÑÐµÐ´Ð¸Ñ', navigate: `/notary/deals/credit`, new: res?.data?.dealCredit },
      ]);
    })
  };

  const [deal, setDeal] = useState(null);

  React.useEffect(() => {
    init();
    update();
  }, [id]);

  const update = async () => {
  };

  return (
    <>
      <Header title={id ? `Ð¡Ð´ÐµÐ»ÐºÐ° ID ${id}` : 'ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ°'} icon={leads} />
      <Breadcrumbs navigate={'/deals'} link={'Ð¡Ð´ÐµÐ»ÐºÐ¸'} currentPage={id ? `Ð¡Ð´ÐµÐ»ÐºÐ° ID ${id}` : 'ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ°'} />
      <Navbar items={items} />
      <Outlet context={[equipmentsCount, init, deal]} />
    </>
  );
};

export default NotaryDealNavigation;
